export const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth;

export const wait = (conditionFunction) => {
  const poll = resolve => {
    if ( conditionFunction() ) {
      resolve();
    } else {
      setTimeout(() => poll(resolve), 500);
    }
  };

  return new Promise(poll);
};

export const onClassChange = (node, callback) => {
  const mutationObserver = new MutationObserver((mutationList) => {
    for (const item of mutationList) {
      if ( item.attributeName === 'class' ) {
        callback(mutationObserver);
      }
    }
  });

  mutationObserver.observe(node, { attributes: true });

  return mutationObserver;
};

export const isChChatBotInitialized = () => 'chMethod' in window;


// WEBPACK FOOTER //
// ./src/assets/js/utils/helpers.js